var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExercise02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    y: 0.53125,
    width: 350,
    height: 233,
    fill: "#D38D8D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 218.035,
    y: 77.1328,
    width: 50.0708,
    height: 22.2537,
    rx: 4,
    fill: "#C3CCFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 230.553,
    y: 77.1328,
    width: 25.0354,
    height: 89.0148,
    fill: "#C3CCFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.553 99.3984H255.588V121.802L230.553 105.103V99.3984Z",
    fill: "#9AA5E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 218.035,
    y: 143.895,
    width: 50.0708,
    height: 22.2537,
    rx: 4,
    fill: "#C3CCFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 254.006,
    y: 104.531,
    width: 36.4431,
    height: 16.1969,
    rx: 4,
    transform: "rotate(-18 254.006 104.531)",
    fill: "#4841A6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 262.672,
    y: 101.717,
    width: 18.2215,
    height: 64.7877,
    transform: "rotate(-18 262.672 101.717)",
    fill: "#4841A6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 269.023,
    y: 150.742,
    width: 36.4431,
    height: 16.1969,
    rx: 4,
    transform: "rotate(-18 269.023 150.742)",
    fill: "#4841A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267.658 117.074L284.988 111.443L290.046 127.01L268.96 121.081L267.658 117.074Z",
    fill: "#353071"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise02);
export default __webpack_public_path__ + "static/media/exercise_02.c929f1a138da326bc7d078e107dfd54d.svg";
export { ForwardRef as ReactComponent };